/** One headline number, in the Overview tiles' shape but not a link. Sits in a `<dl>`. */
export function StatTile({ label, value, hint }: { label: string; value: string; hint: string }) {
  return (
    <div className="rounded-lg border border-border-divider bg-surface-bg/40 px-5 py-4">
      <dt className="font-mono text-xs uppercase tracking-widest text-muted">{label}</dt>
      <dd className="mt-1">
        <span className="block font-display text-3xl text-heading tabular-nums">{value}</span>
        <span className="mt-1 block font-serif text-sm text-muted">{hint}</span>
      </dd>
    </div>
  )
}
